(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.AdvanceYourReach",
                {
                    url: "/AdvanceYourReach",
                    component: "advanceYourReach",
                    PageTitle: "Advance Your Reach",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("advanceYourReach",
        {
            templateUrl: "App/Resources/AdvanceYourReach/AdvanceYourReach.template.html",
            controller: advanceYourReachCtrl,
            bindings: {
                states: "<"
            }
        });

    advanceYourReachCtrl.$inject = ["amplitudeService"];

    function advanceYourReachCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line